export default "__VITE_ASSET__CNwwvwr$__"